import React, { useState, useEffect, useRef } from "react";

const TopWeekly = () => {
  const [isDisplay, setIsDisplay] = useState(false);

  return (
    <div className="rank__weekly">
      <div className="zingchart__bxh__vn">
        <div className="chart__title__bxh">
          <a className="title">Việt Nam</a>
          <button className="circle">
            <i className="fa-solid fa-play"></i>
          </button>
        </div>
        <div className="top__vn">
          <div className="top__song__left__vn">
            <span className="number__top_song">1</span>
            <div className="line__vn">-</div>
            <div className="song__content">
              <div className="thumbnail__children">
                <img
                  src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                  alt="thumbnail"
                />
                <i className="fa-solid fa-play"></i>
              </div>
              <div className="song__track__singer">
                <div className="item__song">Cả Một ...</div>
                <a href="#" className="item__single">
                  Noo...
                </a>
              </div>
            </div>
          </div>
          <div className="top__song_right__vn">
            <div className="icon__top__song">
              <div className="media__narrow">
                <div>
                  <i className="fa fa-microphone"></i>
                </div>
              </div>
              <div className="media__narrow fix__narrow">
                <div>
                  <div
                    className="np__menu__option"
                    onClick={() => setIsDisplay(!isDisplay)}
                  >
                    ● ● ●
                  </div>

                  <ul
                    className={`np__menu__children menu__etc__bxh menu__etc__vn ${
                      isDisplay ? "display-block" : ""
                    }`}
                  >
                    <div className="option__chindren__one">
                      <div className="option__chindren__img">
                        <div>
                          <img
                            src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="option__chindren__sub">
                        <h2>Cả Một Trời Thương Nhớ (Live in HOA Concert)</h2>
                        <div>
                          <span>
                            <i className="fa-regular fa-heart"></i> 6K
                          </span>
                          <span>
                            <i className="fa-solid fa-headphones"></i> 138K
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="option__chindren__two">
                      <div className="option__two__item option__chindren__down">
                        <i className="fa-solid fa-download"></i>
                        <div>Tải xuống</div>
                      </div>
                      <div className="option__two__item option__chindren__sing">
                        <i className="fa-solid fa-microphone"></i>
                        <div>Lời bài hát</div>
                      </div>
                      <div className="option__two__item option__chindren__block">
                        <i className="fa-solid fa-ban"></i>
                        <div>Chặn</div>
                      </div>
                    </div>
                    <li className="active__playlist">
                      <i className="fa-solid fa-circle-plus"></i>
                      <span>
                        Thêm vào playlist{" "}
                        <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="form__playList">
                        <div>
                          <input
                            type="text"
                            name="search__playlist"
                            className="search__playlist"
                            placeholder="Tìm playlist"
                          />
                        </div>
                        <li>
                          <i className="fa fa-plus-square"></i> Tạo playlist mới
                        </li>
                        <nav className="list__playlist">
                          <li>
                            <div className="list_playlist__item">
                              <nav>
                                <i className="fa fa-list-ol"></i>
                              </nav>
                              Love
                            </div>
                          </li>
                        </nav>
                      </ul>
                    </li>
                    <li>
                      <i className="fa fa-microphone"></i>
                      <span>Phát cùng lời bài hát</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-comment"></i>
                      <span>Bình luận</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-link"></i>
                      <span>Sao chép link</span>
                    </li>
                    <li className="option__share">
                      <i className="fa-solid fa-share"></i>
                      <span>
                        Chia sẻ <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="item__share">
                        <li className="icon__fb">
                          <i className="fa-brands fa-facebook"></i> Faboock
                        </li>
                        <li className="icon__zalo">
                          <i className="fa-solid fa-comment-dots"></i> Zalo
                        </li>
                        <li>
                          <i className="fa-solid fa-code"></i> Mã nhúng
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="duration__time__song">04.20</div>
          </div>
        </div>
        <div className="top__vn">
          <div className="top__song__left__vn">
            <span className="number__top_song">1</span>
            <div className="line__vn">-</div>
            <div className="song__content">
              <div className="thumbnail__children">
                <img
                  src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                  alt="thumbnail"
                />
                <i className="fa-solid fa-play"></i>
              </div>
              <div className="song__track__singer">
                <div className="item__song">Cả Một ...</div>
                <a href="#" className="item__single">
                  Noo...
                </a>
              </div>
            </div>
          </div>
          <div className="top__song_right__vn">
            <div className="icon__top__song">
              <div className="media__narrow">
                <div>
                  <i className="fa fa-microphone"></i>
                </div>
              </div>
              <div className="media__narrow fix__narrow">
                <div>
                  <div
                    className="np__menu__option"
                    onClick={() => setIsDisplay(!isDisplay)}
                  >
                    ● ● ●
                  </div>

                  <ul
                    className={`np__menu__children menu__etc__bxh menu__etc__vn ${
                      isDisplay ? "display-block" : ""
                    }`}
                  >
                    <div className="option__chindren__one">
                      <div className="option__chindren__img">
                        <div>
                          <img
                            src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="option__chindren__sub">
                        <h2>Cả Một Trời Thương Nhớ (Live in HOA Concert)</h2>
                        <div>
                          <span>
                            <i className="fa-regular fa-heart"></i> 6K
                          </span>
                          <span>
                            <i className="fa-solid fa-headphones"></i> 138K
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="option__chindren__two">
                      <div className="option__two__item option__chindren__down">
                        <i className="fa-solid fa-download"></i>
                        <div>Tải xuống</div>
                      </div>
                      <div className="option__two__item option__chindren__sing">
                        <i className="fa-solid fa-microphone"></i>
                        <div>Lời bài hát</div>
                      </div>
                      <div className="option__two__item option__chindren__block">
                        <i className="fa-solid fa-ban"></i>
                        <div>Chặn</div>
                      </div>
                    </div>
                    <li className="active__playlist">
                      <i className="fa-solid fa-circle-plus"></i>
                      <span>
                        Thêm vào playlist{" "}
                        <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="form__playList">
                        <div>
                          <input
                            type="text"
                            name="search__playlist"
                            className="search__playlist"
                            placeholder="Tìm playlist"
                          />
                        </div>
                        <li>
                          <i className="fa fa-plus-square"></i> Tạo playlist mới
                        </li>
                        <nav className="list__playlist">
                          <li>
                            <div className="list_playlist__item">
                              <nav>
                                <i className="fa fa-list-ol"></i>
                              </nav>
                              Love
                            </div>
                          </li>
                        </nav>
                      </ul>
                    </li>
                    <li>
                      <i className="fa fa-microphone"></i>
                      <span>Phát cùng lời bài hát</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-comment"></i>
                      <span>Bình luận</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-link"></i>
                      <span>Sao chép link</span>
                    </li>
                    <li className="option__share">
                      <i className="fa-solid fa-share"></i>
                      <span>
                        Chia sẻ <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="item__share">
                        <li className="icon__fb">
                          <i className="fa-brands fa-facebook"></i> Faboock
                        </li>
                        <li className="icon__zalo">
                          <i className="fa-solid fa-comment-dots"></i> Zalo
                        </li>
                        <li>
                          <i className="fa-solid fa-code"></i> Mã nhúng
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="duration__time__song">04.20</div>
          </div>
        </div>
        <div className="top__vn">
          <div className="top__song__left__vn">
            <span className="number__top_song">1</span>
            <div className="line__vn">-</div>
            <div className="song__content">
              <div className="thumbnail__children">
                <img
                  src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                  alt="thumbnail"
                />
                <i className="fa-solid fa-play"></i>
              </div>
              <div className="song__track__singer">
                <div className="item__song">Cả Một ...</div>
                <a href="#" className="item__single">
                  Noo...
                </a>
              </div>
            </div>
          </div>
          <div className="top__song_right__vn">
            <div className="icon__top__song">
              <div className="media__narrow">
                <div>
                  <i className="fa fa-microphone"></i>
                </div>
              </div>
              <div className="media__narrow fix__narrow">
                <div>
                  <div
                    className="np__menu__option"
                    onClick={() => setIsDisplay(!isDisplay)}
                  >
                    ● ● ●
                  </div>

                  <ul
                    className={`np__menu__children menu__etc__bxh menu__etc__vn ${
                      isDisplay ? "display-block" : ""
                    }`}
                  >
                    <div className="option__chindren__one">
                      <div className="option__chindren__img">
                        <div>
                          <img
                            src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="option__chindren__sub">
                        <h2>Cả Một Trời Thương Nhớ (Live in HOA Concert)</h2>
                        <div>
                          <span>
                            <i className="fa-regular fa-heart"></i> 6K
                          </span>
                          <span>
                            <i className="fa-solid fa-headphones"></i> 138K
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="option__chindren__two">
                      <div className="option__two__item option__chindren__down">
                        <i className="fa-solid fa-download"></i>
                        <div>Tải xuống</div>
                      </div>
                      <div className="option__two__item option__chindren__sing">
                        <i className="fa-solid fa-microphone"></i>
                        <div>Lời bài hát</div>
                      </div>
                      <div className="option__two__item option__chindren__block">
                        <i className="fa-solid fa-ban"></i>
                        <div>Chặn</div>
                      </div>
                    </div>
                    <li className="active__playlist">
                      <i className="fa-solid fa-circle-plus"></i>
                      <span>
                        Thêm vào playlist{" "}
                        <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="form__playList">
                        <div>
                          <input
                            type="text"
                            name="search__playlist"
                            className="search__playlist"
                            placeholder="Tìm playlist"
                          />
                        </div>
                        <li>
                          <i className="fa fa-plus-square"></i> Tạo playlist mới
                        </li>
                        <nav className="list__playlist">
                          <li>
                            <div className="list_playlist__item">
                              <nav>
                                <i className="fa fa-list-ol"></i>
                              </nav>
                              Love
                            </div>
                          </li>
                        </nav>
                      </ul>
                    </li>
                    <li>
                      <i className="fa fa-microphone"></i>
                      <span>Phát cùng lời bài hát</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-comment"></i>
                      <span>Bình luận</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-link"></i>
                      <span>Sao chép link</span>
                    </li>
                    <li className="option__share">
                      <i className="fa-solid fa-share"></i>
                      <span>
                        Chia sẻ <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="item__share">
                        <li className="icon__fb">
                          <i className="fa-brands fa-facebook"></i> Faboock
                        </li>
                        <li className="icon__zalo">
                          <i className="fa-solid fa-comment-dots"></i> Zalo
                        </li>
                        <li>
                          <i className="fa-solid fa-code"></i> Mã nhúng
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="duration__time__song">04.20</div>
          </div>
        </div>
        <div className="top__vn">
          <div className="top__song__left__vn">
            <span className="number__top_song">1</span>
            <div className="line__vn">-</div>
            <div className="song__content">
              <div className="thumbnail__children">
                <img
                  src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                  alt="thumbnail"
                />
                <i className="fa-solid fa-play"></i>
              </div>
              <div className="song__track__singer">
                <div className="item__song">Cả Một ...</div>
                <a href="#" className="item__single">
                  Noo...
                </a>
              </div>
            </div>
          </div>
          <div className="top__song_right__vn">
            <div className="icon__top__song">
              <div className="media__narrow">
                <div>
                  <i className="fa fa-microphone"></i>
                </div>
              </div>
              <div className="media__narrow fix__narrow">
                <div>
                  <div
                    className="np__menu__option"
                    onClick={() => setIsDisplay(!isDisplay)}
                  >
                    ● ● ●
                  </div>

                  <ul
                    className={`np__menu__children menu__etc__bxh menu__etc__vn ${
                      isDisplay ? "display-block" : ""
                    }`}
                  >
                    <div className="option__chindren__one">
                      <div className="option__chindren__img">
                        <div>
                          <img
                            src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="option__chindren__sub">
                        <h2>Cả Một Trời Thương Nhớ (Live in HOA Concert)</h2>
                        <div>
                          <span>
                            <i className="fa-regular fa-heart"></i> 6K
                          </span>
                          <span>
                            <i className="fa-solid fa-headphones"></i> 138K
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="option__chindren__two">
                      <div className="option__two__item option__chindren__down">
                        <i className="fa-solid fa-download"></i>
                        <div>Tải xuống</div>
                      </div>
                      <div className="option__two__item option__chindren__sing">
                        <i className="fa-solid fa-microphone"></i>
                        <div>Lời bài hát</div>
                      </div>
                      <div className="option__two__item option__chindren__block">
                        <i className="fa-solid fa-ban"></i>
                        <div>Chặn</div>
                      </div>
                    </div>
                    <li className="active__playlist">
                      <i className="fa-solid fa-circle-plus"></i>
                      <span>
                        Thêm vào playlist{" "}
                        <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="form__playList">
                        <div>
                          <input
                            type="text"
                            name="search__playlist"
                            className="search__playlist"
                            placeholder="Tìm playlist"
                          />
                        </div>
                        <li>
                          <i className="fa fa-plus-square"></i> Tạo playlist mới
                        </li>
                        <nav className="list__playlist">
                          <li>
                            <div className="list_playlist__item">
                              <nav>
                                <i className="fa fa-list-ol"></i>
                              </nav>
                              Love
                            </div>
                          </li>
                        </nav>
                      </ul>
                    </li>
                    <li>
                      <i className="fa fa-microphone"></i>
                      <span>Phát cùng lời bài hát</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-comment"></i>
                      <span>Bình luận</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-link"></i>
                      <span>Sao chép link</span>
                    </li>
                    <li className="option__share">
                      <i className="fa-solid fa-share"></i>
                      <span>
                        Chia sẻ <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="item__share">
                        <li className="icon__fb">
                          <i className="fa-brands fa-facebook"></i> Faboock
                        </li>
                        <li className="icon__zalo">
                          <i className="fa-solid fa-comment-dots"></i> Zalo
                        </li>
                        <li>
                          <i className="fa-solid fa-code"></i> Mã nhúng
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="duration__time__song">04.20</div>
          </div>
        </div>
        <div className="top__vn">
          <div className="top__song__left__vn">
            <span className="number__top_song">1</span>
            <div className="line__vn">-</div>
            <div className="song__content">
              <div className="thumbnail__children">
                <img
                  src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                  alt="thumbnail"
                />
                <i className="fa-solid fa-play"></i>
              </div>
              <div className="song__track__singer">
                <div className="item__song">Cả Một ...</div>
                <a href="#" className="item__single">
                  Noo...
                </a>
              </div>
            </div>
          </div>
          <div className="top__song_right__vn">
            <div className="icon__top__song">
              <div className="media__narrow">
                <div>
                  <i className="fa fa-microphone"></i>
                </div>
              </div>
              <div className="media__narrow fix__narrow">
                <div>
                  <div
                    className="np__menu__option"
                    onClick={() => setIsDisplay(!isDisplay)}
                  >
                    ● ● ●
                  </div>

                  <ul
                    className={`np__menu__children menu__etc__bxh menu__etc__vn ${
                      isDisplay ? "display-block" : ""
                    }`}
                  >
                    <div className="option__chindren__one">
                      <div className="option__chindren__img">
                        <div>
                          <img
                            src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="option__chindren__sub">
                        <h2>Cả Một Trời Thương Nhớ (Live in HOA Concert)</h2>
                        <div>
                          <span>
                            <i className="fa-regular fa-heart"></i> 6K
                          </span>
                          <span>
                            <i className="fa-solid fa-headphones"></i> 138K
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="option__chindren__two">
                      <div className="option__two__item option__chindren__down">
                        <i className="fa-solid fa-download"></i>
                        <div>Tải xuống</div>
                      </div>
                      <div className="option__two__item option__chindren__sing">
                        <i className="fa-solid fa-microphone"></i>
                        <div>Lời bài hát</div>
                      </div>
                      <div className="option__two__item option__chindren__block">
                        <i className="fa-solid fa-ban"></i>
                        <div>Chặn</div>
                      </div>
                    </div>
                    <li className="active__playlist">
                      <i className="fa-solid fa-circle-plus"></i>
                      <span>
                        Thêm vào playlist{" "}
                        <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="form__playList">
                        <div>
                          <input
                            type="text"
                            name="search__playlist"
                            className="search__playlist"
                            placeholder="Tìm playlist"
                          />
                        </div>
                        <li>
                          <i className="fa fa-plus-square"></i> Tạo playlist mới
                        </li>
                        <nav className="list__playlist">
                          <li>
                            <div className="list_playlist__item">
                              <nav>
                                <i className="fa fa-list-ol"></i>
                              </nav>
                              Love
                            </div>
                          </li>
                        </nav>
                      </ul>
                    </li>
                    <li>
                      <i className="fa fa-microphone"></i>
                      <span>Phát cùng lời bài hát</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-comment"></i>
                      <span>Bình luận</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-link"></i>
                      <span>Sao chép link</span>
                    </li>
                    <li className="option__share">
                      <i className="fa-solid fa-share"></i>
                      <span>
                        Chia sẻ <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="item__share">
                        <li className="icon__fb">
                          <i className="fa-brands fa-facebook"></i> Faboock
                        </li>
                        <li className="icon__zalo">
                          <i className="fa-solid fa-comment-dots"></i> Zalo
                        </li>
                        <li>
                          <i className="fa-solid fa-code"></i> Mã nhúng
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="duration__time__song">04.20</div>
          </div>
        </div>

        <div className="jus__content">
          <button className="zm__btn">Xem tất cả</button>
        </div>
      </div>
      <div className="zingchart__bxh__us">
        <div className="chart__title__bxh">
          <a className="title">US-UK</a>
          <button className="circle">
            <i className="fa-solid fa-play"></i>
          </button>
        </div>
        <div className="top__vn">
          <div className="top__song__left__vn">
            <span className="number__top_song">1</span>
            <div className="line__vn">-</div>
            <div className="song__content">
              <div className="thumbnail__children">
                <img
                  src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                  alt="thumbnail"
                />
                <i className="fa-solid fa-play"></i>
              </div>
              <div className="song__track__singer">
                <div className="item__song">Cả Một ...</div>
                <a href="#" className="item__single">
                  Noo...
                </a>
              </div>
            </div>
          </div>
          <div className="top__song_right__vn">
            <div className="icon__top__song">
              <div className="media__narrow">
                <div>
                  <i className="fa fa-microphone"></i>
                </div>
              </div>
              <div className="media__narrow fix__narrow">
                <div>
                  <div className="np__menu__option">● ● ●</div>
                  <ul
                    className={`np__menu__children menu__etc__bxh menu__etc__vn ${
                      isDisplay ? "display-block" : ""
                    }`}
                  >
                    <div className="option__chindren__one">
                      <div className="option__chindren__img">
                        <div>
                          <img
                            src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="option__chindren__sub">
                        <h2>Cả Một Trời Thương Nhớ (Live in HOA Concert)</h2>
                        <div>
                          <span>
                            <i className="fa-regular fa-heart"></i> 6K
                          </span>
                          <span>
                            <i className="fa-solid fa-headphones"></i> 138K
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="option__chindren__two">
                      <div className="option__two__item option__chindren__down">
                        <i className="fa-solid fa-download"></i>
                        <div>Tải xuống</div>
                      </div>
                      <div className="option__two__item option__chindren__sing">
                        <i className="fa-solid fa-microphone"></i>
                        <div>Lời bài hát</div>
                      </div>
                      <div className="option__two__item option__chindren__block">
                        <i className="fa-solid fa-ban"></i>
                        <div>Chặn</div>
                      </div>
                    </div>
                    <li className="active__playlist">
                      <i className="fa-solid fa-circle-plus"></i>
                      <span>
                        Thêm vào playlist{" "}
                        <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="form__playList">
                        <div>
                          <input
                            type="text"
                            name="search__playlist"
                            className="search__playlist"
                            placeholder="Tìm playlist"
                          />
                        </div>
                        <li>
                          <i className="fa fa-plus-square"></i> Tạo playlist mới
                        </li>
                        <nav className="list__playlist">
                          <li>
                            <div className="list_playlist__item">
                              <nav>
                                <i className="fa fa-list-ol"></i>
                              </nav>
                              Love
                            </div>
                          </li>
                        </nav>
                      </ul>
                    </li>
                    <li>
                      <i className="fa fa-microphone"></i>
                      <span>Phát cùng lời bài hát</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-comment"></i>
                      <span>Bình luận</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-link"></i>
                      <span>Sao chép link</span>
                    </li>
                    <li className="option__share">
                      <i className="fa-solid fa-share"></i>
                      <span>
                        Chia sẻ <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="item__share">
                        <li className="icon__fb">
                          <i className="fa-brands fa-facebook"></i> Faboock
                        </li>
                        <li className="icon__zalo">
                          <i className="fa-solid fa-comment-dots"></i> Zalo
                        </li>
                        <li>
                          <i className="fa-solid fa-code"></i> Mã nhúng
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="duration__time__song">04.20</div>
          </div>
        </div>
        <div className="top__vn">
          <div className="top__song__left__vn">
            <span className="number__top_song">1</span>
            <div className="line__vn">-</div>
            <div className="song__content">
              <div className="thumbnail__children">
                <img
                  src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                  alt="thumbnail"
                />
                <i className="fa-solid fa-play"></i>
              </div>
              <div className="song__track__singer">
                <div className="item__song">Cả Một ...</div>
                <a href="#" className="item__single">
                  Noo...
                </a>
              </div>
            </div>
          </div>
          <div className="top__song_right__vn">
            <div className="icon__top__song">
              <div className="media__narrow">
                <div>
                  <i className="fa fa-microphone"></i>
                </div>
              </div>
              <div className="media__narrow fix__narrow">
                <div>
                  <div className="np__menu__option">● ● ●</div>
                  <ul
                    className={`np__menu__children menu__etc__bxh menu__etc__vn ${
                      isDisplay ? "display-block" : ""
                    }`}
                  >
                    <div className="option__chindren__one">
                      <div className="option__chindren__img">
                        <div>
                          <img
                            src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="option__chindren__sub">
                        <h2>Cả Một Trời Thương Nhớ (Live in HOA Concert)</h2>
                        <div>
                          <span>
                            <i className="fa-regular fa-heart"></i> 6K
                          </span>
                          <span>
                            <i className="fa-solid fa-headphones"></i> 138K
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="option__chindren__two">
                      <div className="option__two__item option__chindren__down">
                        <i className="fa-solid fa-download"></i>
                        <div>Tải xuống</div>
                      </div>
                      <div className="option__two__item option__chindren__sing">
                        <i className="fa-solid fa-microphone"></i>
                        <div>Lời bài hát</div>
                      </div>
                      <div className="option__two__item option__chindren__block">
                        <i className="fa-solid fa-ban"></i>
                        <div>Chặn</div>
                      </div>
                    </div>
                    <li className="active__playlist">
                      <i className="fa-solid fa-circle-plus"></i>
                      <span>
                        Thêm vào playlist{" "}
                        <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="form__playList">
                        <div>
                          <input
                            type="text"
                            name="search__playlist"
                            className="search__playlist"
                            placeholder="Tìm playlist"
                          />
                        </div>
                        <li>
                          <i className="fa fa-plus-square"></i> Tạo playlist mới
                        </li>
                        <nav className="list__playlist">
                          <li>
                            <div className="list_playlist__item">
                              <nav>
                                <i className="fa fa-list-ol"></i>
                              </nav>
                              Love
                            </div>
                          </li>
                        </nav>
                      </ul>
                    </li>
                    <li>
                      <i className="fa fa-microphone"></i>
                      <span>Phát cùng lời bài hát</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-comment"></i>
                      <span>Bình luận</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-link"></i>
                      <span>Sao chép link</span>
                    </li>
                    <li className="option__share">
                      <i className="fa-solid fa-share"></i>
                      <span>
                        Chia sẻ <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="item__share">
                        <li className="icon__fb">
                          <i className="fa-brands fa-facebook"></i> Faboock
                        </li>
                        <li className="icon__zalo">
                          <i className="fa-solid fa-comment-dots"></i> Zalo
                        </li>
                        <li>
                          <i className="fa-solid fa-code"></i> Mã nhúng
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="duration__time__song">04.20</div>
          </div>
        </div>
        <div className="top__vn">
          <div className="top__song__left__vn">
            <span className="number__top_song">1</span>
            <div className="line__vn">-</div>
            <div className="song__content">
              <div className="thumbnail__children">
                <img
                  src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                  alt="thumbnail"
                />
                <i className="fa-solid fa-play"></i>
              </div>
              <div className="song__track__singer">
                <div className="item__song">Cả Một ...</div>
                <a href="#" className="item__single">
                  Noo...
                </a>
              </div>
            </div>
          </div>
          <div className="top__song_right__vn">
            <div className="icon__top__song">
              <div className="media__narrow">
                <div>
                  <i className="fa fa-microphone"></i>
                </div>
              </div>
              <div className="media__narrow fix__narrow">
                <div>
                  <div className="np__menu__option">● ● ●</div>
                  <ul
                    className={`np__menu__children menu__etc__bxh menu__etc__vn ${
                      isDisplay ? "display-block" : ""
                    }`}
                  >
                    <div className="option__chindren__one">
                      <div className="option__chindren__img">
                        <div>
                          <img
                            src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="option__chindren__sub">
                        <h2>Cả Một Trời Thương Nhớ (Live in HOA Concert)</h2>
                        <div>
                          <span>
                            <i className="fa-regular fa-heart"></i> 6K
                          </span>
                          <span>
                            <i className="fa-solid fa-headphones"></i> 138K
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="option__chindren__two">
                      <div className="option__two__item option__chindren__down">
                        <i className="fa-solid fa-download"></i>
                        <div>Tải xuống</div>
                      </div>
                      <div className="option__two__item option__chindren__sing">
                        <i className="fa-solid fa-microphone"></i>
                        <div>Lời bài hát</div>
                      </div>
                      <div className="option__two__item option__chindren__block">
                        <i className="fa-solid fa-ban"></i>
                        <div>Chặn</div>
                      </div>
                    </div>
                    <li className="active__playlist">
                      <i className="fa-solid fa-circle-plus"></i>
                      <span>
                        Thêm vào playlist{" "}
                        <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="form__playList">
                        <div>
                          <input
                            type="text"
                            name="search__playlist"
                            className="search__playlist"
                            placeholder="Tìm playlist"
                          />
                        </div>
                        <li>
                          <i className="fa fa-plus-square"></i> Tạo playlist mới
                        </li>
                        <nav className="list__playlist">
                          <li>
                            <div className="list_playlist__item">
                              <nav>
                                <i className="fa fa-list-ol"></i>
                              </nav>
                              Love
                            </div>
                          </li>
                        </nav>
                      </ul>
                    </li>
                    <li>
                      <i className="fa fa-microphone"></i>
                      <span>Phát cùng lời bài hát</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-comment"></i>
                      <span>Bình luận</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-link"></i>
                      <span>Sao chép link</span>
                    </li>
                    <li className="option__share">
                      <i className="fa-solid fa-share"></i>
                      <span>
                        Chia sẻ <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="item__share">
                        <li className="icon__fb">
                          <i className="fa-brands fa-facebook"></i> Faboock
                        </li>
                        <li className="icon__zalo">
                          <i className="fa-solid fa-comment-dots"></i> Zalo
                        </li>
                        <li>
                          <i className="fa-solid fa-code"></i> Mã nhúng
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="duration__time__song">04.20</div>
          </div>
        </div>
        <div className="top__vn">
          <div className="top__song__left__vn">
            <span className="number__top_song">1</span>
            <div className="line__vn">-</div>
            <div className="song__content">
              <div className="thumbnail__children">
                <img
                  src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                  alt="thumbnail"
                />
                <i className="fa-solid fa-play"></i>
              </div>
              <div className="song__track__singer">
                <div className="item__song">Cả Một ...</div>
                <a href="#" className="item__single">
                  Noo...
                </a>
              </div>
            </div>
          </div>
          <div className="top__song_right__vn">
            <div className="icon__top__song">
              <div className="media__narrow">
                <div>
                  <i className="fa fa-microphone"></i>
                </div>
              </div>
              <div className="media__narrow fix__narrow">
                <div>
                  <div className="np__menu__option">● ● ●</div>
                  <ul
                    className={`np__menu__children menu__etc__bxh menu__etc__vn ${
                      isDisplay ? "display-block" : ""
                    }`}
                  >
                    <div className="option__chindren__one">
                      <div className="option__chindren__img">
                        <div>
                          <img
                            src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="option__chindren__sub">
                        <h2>Cả Một Trời Thương Nhớ (Live in HOA Concert)</h2>
                        <div>
                          <span>
                            <i className="fa-regular fa-heart"></i> 6K
                          </span>
                          <span>
                            <i className="fa-solid fa-headphones"></i> 138K
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="option__chindren__two">
                      <div className="option__two__item option__chindren__down">
                        <i className="fa-solid fa-download"></i>
                        <div>Tải xuống</div>
                      </div>
                      <div className="option__two__item option__chindren__sing">
                        <i className="fa-solid fa-microphone"></i>
                        <div>Lời bài hát</div>
                      </div>
                      <div className="option__two__item option__chindren__block">
                        <i className="fa-solid fa-ban"></i>
                        <div>Chặn</div>
                      </div>
                    </div>
                    <li className="active__playlist">
                      <i className="fa-solid fa-circle-plus"></i>
                      <span>
                        Thêm vào playlist{" "}
                        <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="form__playList">
                        <div>
                          <input
                            type="text"
                            name="search__playlist"
                            className="search__playlist"
                            placeholder="Tìm playlist"
                          />
                        </div>
                        <li>
                          <i className="fa fa-plus-square"></i> Tạo playlist mới
                        </li>
                        <nav className="list__playlist">
                          <li>
                            <div className="list_playlist__item">
                              <nav>
                                <i className="fa fa-list-ol"></i>
                              </nav>
                              Love
                            </div>
                          </li>
                        </nav>
                      </ul>
                    </li>
                    <li>
                      <i className="fa fa-microphone"></i>
                      <span>Phát cùng lời bài hát</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-comment"></i>
                      <span>Bình luận</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-link"></i>
                      <span>Sao chép link</span>
                    </li>
                    <li className="option__share">
                      <i className="fa-solid fa-share"></i>
                      <span>
                        Chia sẻ <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="item__share">
                        <li className="icon__fb">
                          <i className="fa-brands fa-facebook"></i> Faboock
                        </li>
                        <li className="icon__zalo">
                          <i className="fa-solid fa-comment-dots"></i> Zalo
                        </li>
                        <li>
                          <i className="fa-solid fa-code"></i> Mã nhúng
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="duration__time__song">04.20</div>
          </div>
        </div>
        <div className="top__vn">
          <div className="top__song__left__vn">
            <span className="number__top_song">1</span>
            <div className="line__vn">-</div>
            <div className="song__content">
              <div className="thumbnail__children">
                <img
                  src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                  alt="thumbnail"
                />
                <i className="fa-solid fa-play"></i>
              </div>
              <div className="song__track__singer">
                <div className="item__song">Cả Một ...</div>
                <a href="#" className="item__single">
                  Noo...
                </a>
              </div>
            </div>
          </div>
          <div className="top__song_right__vn">
            <div className="icon__top__song">
              <div className="media__narrow">
                <div>
                  <i className="fa fa-microphone"></i>
                </div>
              </div>
              <div className="media__narrow fix__narrow">
                <div>
                  <div className="np__menu__option">● ● ●</div>
                  <ul
                    className={`np__menu__children menu__etc__bxh menu__etc__vn ${
                      isDisplay ? "display-block" : ""
                    }`}
                  >
                    <div className="option__chindren__one">
                      <div className="option__chindren__img">
                        <div>
                          <img
                            src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="option__chindren__sub">
                        <h2>Cả Một Trời Thương Nhớ (Live in HOA Concert)</h2>
                        <div>
                          <span>
                            <i className="fa-regular fa-heart"></i> 6K
                          </span>
                          <span>
                            <i className="fa-solid fa-headphones"></i> 138K
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="option__chindren__two">
                      <div className="option__two__item option__chindren__down">
                        <i className="fa-solid fa-download"></i>
                        <div>Tải xuống</div>
                      </div>
                      <div className="option__two__item option__chindren__sing">
                        <i className="fa-solid fa-microphone"></i>
                        <div>Lời bài hát</div>
                      </div>
                      <div className="option__two__item option__chindren__block">
                        <i className="fa-solid fa-ban"></i>
                        <div>Chặn</div>
                      </div>
                    </div>
                    <li className="active__playlist">
                      <i className="fa-solid fa-circle-plus"></i>
                      <span>
                        Thêm vào playlist{" "}
                        <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="form__playList">
                        <div>
                          <input
                            type="text"
                            name="search__playlist"
                            className="search__playlist"
                            placeholder="Tìm playlist"
                          />
                        </div>
                        <li>
                          <i className="fa fa-plus-square"></i> Tạo playlist mới
                        </li>
                        <nav className="list__playlist">
                          <li>
                            <div className="list_playlist__item">
                              <nav>
                                <i className="fa fa-list-ol"></i>
                              </nav>
                              Love
                            </div>
                          </li>
                        </nav>
                      </ul>
                    </li>
                    <li>
                      <i className="fa fa-microphone"></i>
                      <span>Phát cùng lời bài hát</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-comment"></i>
                      <span>Bình luận</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-link"></i>
                      <span>Sao chép link</span>
                    </li>
                    <li className="option__share">
                      <i className="fa-solid fa-share"></i>
                      <span>
                        Chia sẻ <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="item__share">
                        <li className="icon__fb">
                          <i className="fa-brands fa-facebook"></i> Faboock
                        </li>
                        <li className="icon__zalo">
                          <i className="fa-solid fa-comment-dots"></i> Zalo
                        </li>
                        <li>
                          <i className="fa-solid fa-code"></i> Mã nhúng
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="duration__time__song">04.20</div>
          </div>
        </div>
        <div className="jus__content">
          <button className="zm__btn">Xem tất cả</button>
        </div>
      </div>
      <div className="zingchart__bxh__kpop">
        <div className="chart__title__bxh">
          <a className="title">K-POP</a>
          <button className="circle">
            <i className="fa-solid fa-play"></i>
          </button>
        </div>
        <div className="top__vn">
          <div className="top__song__left__vn">
            <span className="number__top_song">1</span>
            <div className="line__vn">-</div>
            <div className="song__content">
              <div className="thumbnail__children">
                <img
                  src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                  alt="thumbnail"
                />
                <i className="fa-solid fa-play"></i>
              </div>
              <div className="song__track__singer">
                <div className="item__song">Cả Một ...</div>
                <a href="#" className="item__single">
                  Noo...
                </a>
              </div>
            </div>
          </div>
          <div className="top__song_right__vn">
            <div className="icon__top__song">
              <div className="media__narrow">
                <div>
                  <i className="fa fa-microphone"></i>
                </div>
              </div>
              <div className="media__narrow">
                <div>
                  <div className="np__menu__option">● ● ●</div>
                  <ul className="np__menu__children menu__etc__bxh menu__etc_kpop">
                    <div className="option__chindren__one">
                      <div className="option__chindren__img">
                        <div>
                          <img
                            src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="option__chindren__sub">
                        <h2>Cả Một Trời Thương Nhớ (Live in HOA Concert)</h2>
                        <div>
                          <span>
                            <i className="fa-regular fa-heart"></i> 6K
                          </span>
                          <span>
                            <i className="fa-solid fa-headphones"></i> 138K
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="option__chindren__two">
                      <div className="option__two__item option__chindren__down">
                        <i className="fa-solid fa-download"></i>
                        <div>Tải xuống</div>
                      </div>
                      <div className="option__two__item option__chindren__sing">
                        <i className="fa-solid fa-microphone"></i>
                        <div>Lời bài hát</div>
                      </div>
                      <div className="option__two__item option__chindren__block">
                        <i className="fa-solid fa-ban"></i>
                        <div>Chặn</div>
                      </div>
                    </div>
                    <li className="active__playlist">
                      <i className="fa-solid fa-circle-plus"></i>
                      <span>
                        Thêm vào playlist{" "}
                        <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="form__playList">
                        <div>
                          <input
                            type="text"
                            name="search__playlist"
                            className="search__playlist"
                            placeholder="Tìm playlist"
                          />
                        </div>
                        <li>
                          <i className="fa fa-plus-square"></i> Tạo playlist mới
                        </li>
                        <nav className="list__playlist">
                          <li>
                            <div className="list_playlist__item">
                              <nav>
                                <i className="fa fa-list-ol"></i>
                              </nav>
                              Love
                            </div>
                          </li>
                        </nav>
                      </ul>
                    </li>
                    <li>
                      <i className="fa fa-microphone"></i>
                      <span>Phát cùng lời bài hát</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-comment"></i>
                      <span>Bình luận</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-link"></i>
                      <span>Sao chép link</span>
                    </li>
                    <li className="option__share">
                      <i className="fa-solid fa-share"></i>
                      <span>
                        Chia sẻ <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="item__share">
                        <li className="icon__fb">
                          <i className="fa-brands fa-facebook"></i> Faboock
                        </li>
                        <li className="icon__zalo">
                          <i className="fa-solid fa-comment-dots"></i> Zalo
                        </li>
                        <li>
                          <i className="fa-solid fa-code"></i> Mã nhúng
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="duration__time__song">04.20</div>
          </div>
        </div>
        <div className="top__vn">
          <div className="top__song__left__vn">
            <span className="number__top_song">2</span>
            <div className="line__vn">-</div>
            <div className="song__content">
              <div className="thumbnail__children">
                <img
                  src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                  alt="thumbnail"
                />
                <i className="fa-solid fa-play"></i>
              </div>
              <div className="song__track__singer">
                <div className="item__song">Cả Một ...</div>
                <a href="#" className="item__single">
                  Noo...
                </a>
              </div>
            </div>
          </div>
          <div className="top__song_right__vn">
            <div className="icon__top__song">
              <div className="media__narrow">
                <div>
                  <i className="fa fa-microphone"></i>
                </div>
              </div>
              <div className="media__narrow">
                <div>
                  <div className="np__menu__option">● ● ●</div>
                  <ul className="np__menu__children menu__etc__bxh menu__etc_kpop">
                    <div className="option__chindren__one">
                      <div className="option__chindren__img">
                        <div>
                          <img
                            src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="option__chindren__sub">
                        <h2>Cả Một Trời Thương Nhớ (Live in HOA Concert)</h2>
                        <div>
                          <span>
                            <i className="fa-regular fa-heart"></i> 6K
                          </span>
                          <span>
                            <i className="fa-solid fa-headphones"></i> 138K
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="option__chindren__two">
                      <div className="option__two__item option__chindren__down">
                        <i className="fa-solid fa-download"></i>
                        <div>Tải xuống</div>
                      </div>
                      <div className="option__two__item option__chindren__sing">
                        <i className="fa-solid fa-microphone"></i>
                        <div>Lời bài hát</div>
                      </div>
                      <div className="option__two__item option__chindren__block">
                        <i className="fa-solid fa-ban"></i>
                        <div>Chặn</div>
                      </div>
                    </div>
                    <li className="active__playlist">
                      <i className="fa-solid fa-circle-plus"></i>
                      <span>
                        Thêm vào playlist{" "}
                        <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="form__playList">
                        <div>
                          <input
                            type="text"
                            name="search__playlist"
                            className="search__playlist"
                            placeholder="Tìm playlist"
                          />
                        </div>
                        <li>
                          <i className="fa fa-plus-square"></i> Tạo playlist mới
                        </li>
                        <nav className="list__playlist">
                          <li>
                            <div className="list_playlist__item">
                              <nav>
                                <i className="fa fa-list-ol"></i>
                              </nav>
                              Love
                            </div>
                          </li>
                        </nav>
                      </ul>
                    </li>
                    <li>
                      <i className="fa fa-microphone"></i>
                      <span>Phát cùng lời bài hát</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-comment"></i>
                      <span>Bình luận</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-link"></i>
                      <span>Sao chép link</span>
                    </li>
                    <li className="option__share">
                      <i className="fa-solid fa-share"></i>
                      <span>
                        Chia sẻ <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="item__share">
                        <li className="icon__fb">
                          <i className="fa-brands fa-facebook"></i> Faboock
                        </li>
                        <li className="icon__zalo">
                          <i className="fa-solid fa-comment-dots"></i> Zalo
                        </li>
                        <li>
                          <i className="fa-solid fa-code"></i> Mã nhúng
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="duration__time__song">04.20</div>
          </div>
        </div>
        <div className="top__vn">
          <div className="top__song__left__vn">
            <span className="number__top_song">3</span>
            <div className="line__vn">-</div>
            <div className="song__content">
              <div className="thumbnail__children">
                <img
                  src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                  alt="thumbnail"
                />
                <i className="fa-solid fa-play"></i>
              </div>
              <div className="song__track__singer">
                <div className="item__song">Cả Một ...</div>
                <a href="#" className="item__single">
                  Noo...
                </a>
              </div>
            </div>
          </div>
          <div className="top__song_right__vn">
            <div className="icon__top__song">
              <div className="media__narrow">
                <div>
                  <i className="fa fa-microphone"></i>
                </div>
              </div>
              <div className="media__narrow">
                <div>
                  <div className="np__menu__option">● ● ●</div>
                  <ul className="np__menu__children menu__etc__bxh menu__etc_kpop">
                    <div className="option__chindren__one">
                      <div className="option__chindren__img">
                        <div>
                          <img
                            src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="option__chindren__sub">
                        <h2>Cả Một Trời Thương Nhớ (Live in HOA Concert)</h2>
                        <div>
                          <span>
                            <i className="fa-regular fa-heart"></i> 6K
                          </span>
                          <span>
                            <i className="fa-solid fa-headphones"></i> 138K
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="option__chindren__two">
                      <div className="option__two__item option__chindren__down">
                        <i className="fa-solid fa-download"></i>
                        <div>Tải xuống</div>
                      </div>
                      <div className="option__two__item option__chindren__sing">
                        <i className="fa-solid fa-microphone"></i>
                        <div>Lời bài hát</div>
                      </div>
                      <div className="option__two__item option__chindren__block">
                        <i className="fa-solid fa-ban"></i>
                        <div>Chặn</div>
                      </div>
                    </div>
                    <li className="active__playlist">
                      <i className="fa-solid fa-circle-plus"></i>
                      <span>
                        Thêm vào playlist{" "}
                        <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="form__playList">
                        <div>
                          <input
                            type="text"
                            name="search__playlist"
                            className="search__playlist"
                            placeholder="Tìm playlist"
                          />
                        </div>
                        <li>
                          <i className="fa fa-plus-square"></i> Tạo playlist mới
                        </li>
                        <nav className="list__playlist">
                          <li>
                            <div className="list_playlist__item">
                              <nav>
                                <i className="fa fa-list-ol"></i>
                              </nav>
                              Love
                            </div>
                          </li>
                        </nav>
                      </ul>
                    </li>
                    <li>
                      <i className="fa fa-microphone"></i>
                      <span>Phát cùng lời bài hát</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-comment"></i>
                      <span>Bình luận</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-link"></i>
                      <span>Sao chép link</span>
                    </li>
                    <li className="option__share">
                      <i className="fa-solid fa-share"></i>
                      <span>
                        Chia sẻ <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="item__share">
                        <li className="icon__fb">
                          <i className="fa-brands fa-facebook"></i> Faboock
                        </li>
                        <li className="icon__zalo">
                          <i className="fa-solid fa-comment-dots"></i> Zalo
                        </li>
                        <li>
                          <i className="fa-solid fa-code"></i> Mã nhúng
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="duration__time__song">04.20</div>
          </div>
        </div>
        <div className="top__vn">
          <div className="top__song__left__vn">
            <span className="number__top_song">4</span>
            <div className="line__vn">-</div>
            <div className="song__content">
              <div className="thumbnail__children">
                <img
                  src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                  alt="thumbnail"
                />
                <i className="fa-solid fa-play"></i>
              </div>
              <div className="song__track__singer">
                <div className="item__song">Cả Một ...</div>
                <a href="#" className="item__single">
                  Noo...
                </a>
              </div>
            </div>
          </div>
          <div className="top__song_right__vn">
            <div className="icon__top__song">
              <div className="media__narrow">
                <div>
                  <i className="fa fa-microphone"></i>
                </div>
              </div>
              <div className="media__narrow">
                <div>
                  <div className="np__menu__option">● ● ●</div>
                  <ul className="np__menu__children menu__etc__bxh menu__etc_kpop">
                    <div className="option__chindren__one">
                      <div className="option__chindren__img">
                        <div>
                          <img
                            src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="option__chindren__sub">
                        <h2>Cả Một Trời Thương Nhớ (Live in HOA Concert)</h2>
                        <div>
                          <span>
                            <i className="fa-regular fa-heart"></i> 6K
                          </span>
                          <span>
                            <i className="fa-solid fa-headphones"></i> 138K
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="option__chindren__two">
                      <div className="option__two__item option__chindren__down">
                        <i className="fa-solid fa-download"></i>
                        <div>Tải xuống</div>
                      </div>
                      <div className="option__two__item option__chindren__sing">
                        <i className="fa-solid fa-microphone"></i>
                        <div>Lời bài hát</div>
                      </div>
                      <div className="option__two__item option__chindren__block">
                        <i className="fa-solid fa-ban"></i>
                        <div>Chặn</div>
                      </div>
                    </div>
                    <li className="active__playlist">
                      <i className="fa-solid fa-circle-plus"></i>
                      <span>
                        Thêm vào playlist{" "}
                        <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="form__playList">
                        <div>
                          <input
                            type="text"
                            name="search__playlist"
                            className="search__playlist"
                            placeholder="Tìm playlist"
                          />
                        </div>
                        <li>
                          <i className="fa fa-plus-square"></i> Tạo playlist mới
                        </li>
                        <nav className="list__playlist">
                          <li>
                            <div className="list_playlist__item">
                              <nav>
                                <i className="fa fa-list-ol"></i>
                              </nav>
                              Love
                            </div>
                          </li>
                        </nav>
                      </ul>
                    </li>
                    <li>
                      <i className="fa fa-microphone"></i>
                      <span>Phát cùng lời bài hát</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-comment"></i>
                      <span>Bình luận</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-link"></i>
                      <span>Sao chép link</span>
                    </li>
                    <li className="option__share">
                      <i className="fa-solid fa-share"></i>
                      <span>
                        Chia sẻ <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="item__share">
                        <li className="icon__fb">
                          <i className="fa-brands fa-facebook"></i> Faboock
                        </li>
                        <li className="icon__zalo">
                          <i className="fa-solid fa-comment-dots"></i> Zalo
                        </li>
                        <li>
                          <i className="fa-solid fa-code"></i> Mã nhúng
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="duration__time__song">04.20</div>
          </div>
        </div>
        <div className="top__vn">
          <div className="top__song__left__vn">
            <span className="number__top_song">5</span>
            <div className="line__vn">-</div>
            <div className="song__content">
              <div className="thumbnail__children">
                <img
                  src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                  alt="thumbnail"
                />
                <i className="fa-solid fa-play"></i>
              </div>
              <div className="song__track__singer">
                <div className="item__song">Cả Một ...</div>
                <a href="#" className="item__single">
                  Noo...
                </a>
              </div>
            </div>
          </div>
          <div className="top__song_right__vn">
            <div className="icon__top__song">
              <div className="media__narrow">
                <div>
                  <i className="fa fa-microphone"></i>
                </div>
              </div>
              <div className="media__narrow">
                <div>
                  <div className="np__menu__option">● ● ●</div>
                  <ul className="np__menu__children menu__etc__bxh menu__etc_kpop">
                    <div className="option__chindren__one">
                      <div className="option__chindren__img">
                        <div>
                          <img
                            src="https://photo-resize-zmp3.zmdcdn.me/w240_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="option__chindren__sub">
                        <h2>Cả Một Trời Thương Nhớ (Live in HOA Concert)</h2>
                        <div>
                          <span>
                            <i className="fa-regular fa-heart"></i> 6K
                          </span>
                          <span>
                            <i className="fa-solid fa-headphones"></i> 138K
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="option__chindren__two">
                      <div className="option__two__item option__chindren__down">
                        <i className="fa-solid fa-download"></i>
                        <div>Tải xuống</div>
                      </div>
                      <div className="option__two__item option__chindren__sing">
                        <i className="fa-solid fa-microphone"></i>
                        <div>Lời bài hát</div>
                      </div>
                      <div className="option__two__item option__chindren__block">
                        <i className="fa-solid fa-ban"></i>
                        <div>Chặn</div>
                      </div>
                    </div>
                    <li className="active__playlist">
                      <i className="fa-solid fa-circle-plus"></i>
                      <span>
                        Thêm vào playlist{" "}
                        <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="form__playList">
                        <div>
                          <input
                            type="text"
                            name="search__playlist"
                            className="search__playlist"
                            placeholder="Tìm playlist"
                          />
                        </div>
                        <li>
                          <i className="fa fa-plus-square"></i> Tạo playlist mới
                        </li>
                        <nav className="list__playlist">
                          <li>
                            <div className="list_playlist__item">
                              <nav>
                                <i className="fa fa-list-ol"></i>
                              </nav>
                              Love
                            </div>
                          </li>
                        </nav>
                      </ul>
                    </li>
                    <li>
                      <i className="fa fa-microphone"></i>
                      <span>Phát cùng lời bài hát</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-comment"></i>
                      <span>Bình luận</span>
                    </li>
                    <li>
                      <i className="fa-solid fa-link"></i>
                      <span>Sao chép link</span>
                    </li>
                    <li className="option__share">
                      <i className="fa-solid fa-share"></i>
                      <span>
                        Chia sẻ <i className="fa-solid fa-chevron-right"></i>
                      </span>
                      <ul className="item__share">
                        <li className="icon__fb">
                          <i className="fa-brands fa-facebook"></i> Faboock
                        </li>
                        <li className="icon__zalo">
                          <i className="fa-solid fa-comment-dots"></i> Zalo
                        </li>
                        <li>
                          <i className="fa-solid fa-code"></i> Mã nhúng
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="duration__time__song">04.20</div>
          </div>
        </div>
        <div className="jus__content">
          <button className="zm__btn">Xem tất cả</button>
        </div>
      </div>
    </div>
  );
};

export default TopWeekly;
